import React from 'react'

import { useTranslation } from 'language/translator'

import Box from 'components_new/atoms/Box'
import Chip from 'components_new/atoms/Chip'
import Divider from 'components_new/atoms/Divider'

import GenericListItem from 'components_new/molecules/GenericListItem'

interface ChatHistoryLinkProps {
  count: number
  onShowAll: () => void
}

const ChatHistoryLink = (props: ChatHistoryLinkProps) => {
  const { count, onShowAll } = props

  const { t } = useTranslation()

  if (count === 0) {
    return null
  }

  return (
    <Box>
      <GenericListItem
        action="to"
        flexTitle={true}
        icon={{ name: 'History' }}
        onClick={onShowAll}
        title={t('chat', 'history_title')}
        titleAdornment={
          <Chip label={String(count)} size="xsmall" sx={{ ml: 1 }} />
        }
      />

      <Divider sx={{ mt: 1 }} />
    </Box>
  )
}

export default ChatHistoryLink
